<template>
  <div class>
    <Form ref="cls" :model="cls" :rules="ruleCls" :label-width="120">
      <FormItem label="班级名称：" prop="class_name">
        <Input
          v-model="cls.class_name"
          :maxlength="30"
          placeholder="请输入班级名称，最多不超过30个字"
          style="width: 400px;"
          clearable
        ></Input>
        <span style="padding-left: 10px;">{{cls.class_name.length}}/30</span>
      </FormItem>
      <FormItem label="选择课程：" prop="courses" v-if="type == 2">
        <Tag
          type="border"
          closable
          v-for="item in cls.courses"
          :key="item.id"
          @on-close="courseDelete()"
        >{{item.title}}</Tag>
        <Button type="default" @click="showSelectCourse=true">
          <i class="ivu-icon ivu-icon-ios-add"></i>选择课程
        </Button>
      </FormItem>
      <FormItem label="选择课程：" prop="courses" v-else>
        <span style="padding-left: 10px;" v-if="cls.courses[0]">{{cls.courses[0].title}}</span>
      </FormItem>
      <FormItem label="选择助教：" prop="assistants">
        <Tag
          type="border"
          closable
          v-for="item in cls.assistants"
          :key="item.id"
          @on-close="assistantDelete()"
        >{{item.real_name}}</Tag>
        <Button type="default" @click="showSelectAssistant=true">
          <i class="ivu-icon ivu-icon-ios-add"></i>选择助教
        </Button>
      </FormItem>
      <FormItem label="班级介绍：" prop="description">
        <Input
          type="textarea"
          v-model="cls.description"
          :maxlength="200"
          placeholder="请输入班级介绍，最多不超过200个字"
          style="width: 400px;"
          :rows="7"
          clearable
        ></Input>
        <span style="padding-left: 10px;">{{cls.description?cls.description.length:0}}/200</span>
      </FormItem>
      <FormItem label="班级人员上限：">
        <span style="padding-left: 10px;">{{limit_number}}</span>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'ClassManage'}">返回</Button>
        <Button size="large" style="margin: 0 15px;" type="primary" @click="submitForm('cls')">保存并返回</Button>
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      @on-cancel="$refs.course.recoverSelectedItems(cls.courses)"
      width="800"
      scrollable
    >
      <course ref="course" :selectedItems="cls.courses" selectType="single" :is_divide_class="1"></course>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectAssistant"
      title="选择助教"
      @on-ok="confirmSelectAssistant"
      @on-cancel="$refs.assistant.recoverSelectedItems(cls.assistants)"
      width="800"
      scrollable
    >
      <assistant ref="assistant" :selectedItems="cls.assistants" selectType="single"></assistant>
    </Modal>
  </div>
</template>

<script>
import course from "@/components/GridSelect/CourseSelect";
import assistant from "@/components/GridSelect/AssistTeacherSelect";
export default {
  name: "",
  components: {
    course,
    assistant
  },
  data() {
    return {
      type: this.$route.query.type, // 1编辑，2新增
      cls: {
        class_name: "",
        description: "",
        courses: [],
        assistants: []
      },
      limit_number: 300,
      ruleCls: {
        class_name: [{ required: true, message: "请输入", trigger: "blur" }],
        courses: [
          {
            required: true,
            type: "array",
            message: "请选择课程",
            trigger: "change"
          }
        ],
        assistants: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择助教",
            trigger: "change"
          }
        ]
      },
      showSelectCourse: false,
      showSelectAssistant: false
    };
  },
  async created() {
    if (this.type == 1) {
      let res = await this.$http.get(`/api/classGrade/${this.$route.query.id}`);
      this.cls.class_name = res.class_name;
      this.cls.description = res.description;
      this.cls.course_basis_id = res.course_basis_id;
      this.limit_number = res.limit_number;
      this.$http
        .get(`/api/course/basis/${res.course_basis_id}`)
        .then(courses => {
          this.cls.courses = [courses];
        });
      this.$http.get(`/api/assistant/${res.assistant_id}`).then(assistant => {
        this.cls.assistants = [assistant];
      });
    }
  },
  methods: {
    courseDelete() {
      this.cls.courses = [];
    },
    assistantDelete() {
      this.cls.assistants = [];
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      this.cls.courses = list;
    },
    confirmSelectAssistant() {
      this.showSelectAssistant = false;
      let list = this.$refs.assistant.getSelectList();
      this.cls.assistants = list;
    },
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            ...this.cls
          };
          delete params.assistants;
          if (!params.course_basis_id) {
            params.course_basis_id = params.courses[0].id;
          }
          if (this.cls.assistants.length > 0) {
            params.assistant_id = this.cls.assistants[0].id;
          }
          delete params.courses;
          if (this.type == 1) {
            // 编辑
            this.$http
              .put(`/api/classGrade/${this.$route.query.id}`, params)
              .then(() => {
                this.$Message.saveSuccess();
                this.$router.push({
                  name: "ClassManage"
                });
              });
          } else {
            // 新增
            this.$http.post(`/api/classGrade`, params).then(() => {
              this.$Message.createSuccess();
              this.$router.push({
                name: "ClassManage"
              });
            });
          }
        } else {
          return;
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
